import { Table } from 'gokwik-ui-kit'

const DataTable = ({ id, tableData, loading, parameters, setParameters, columnHeaders }) => {
    const columns = columnHeaders
        ?.filter((header) => header.is_default === true) // Filter headers based on is_default
        .map((header, i) => ({
            title: header?.label,
            dataIndex: header?.key_name,
            key: i,
            sorter: (a, b) => {
                if (!isNaN(a[header?.key_name]) && !isNaN(b[header?.key_name])) {
                    return a[header?.key_name] - b[header?.key_name]
                }
                return a[header?.key_name]?.localeCompare(b[header?.key_name])
            },
        }))

    const data = tableData?.results

    const handlePagination = (page) => {
        setParameters((prevParams) => {
            const newParams = {
                ...prevParams,
                page: page,
            }

            return newParams
        })
    }

    const onChange = (pagination, filters, sorter, extra) => {}

    const totalSum = tableData?.totalSum

    return (
        <div>
            <style>{`
                    .cam-seg-sum-row {
                        background-color: #e6f4ff;
                        color: black;
                        font-weight: 600;
                        
                    }
                    .cam-seg-sum-row:hover .ant-table-cell-row-hover {
                        background-color: #e6f4ff;
                        color: black;
                        font-weight: 600;
                    }
                        .camp-seg-custom-first-row {
                        position: sticky;
                        top: 0;
                        z-index: 5;
                    }
           
                `}</style>

            <Table
                //@ts-ignore
                className='bg-white'
                columns={columns}
                dataSource={data}
                onChange={onChange}
                showSorterTooltip={{ target: 'sorter-icon' }}
                rowClassName={(row, index) => {
                    if (index === 0) {
                        return 'first-row'
                    }
                }}
                pagination={{
                    current: parameters?.page,
                    pageSize: 15,
                    total: tableData?.totalCount,
                    showSizeChanger: false,
                    onChange: handlePagination,
                    position: ['bottomLeft', 'topLeft'],
                    showTotal: (total, range) => `Showing ${range[0]}-${range[1]} of ${total} Records`,
                }}
                scroll={{ x: 'max-content' }}
                loading={loading}
            />
        </div>
    )
}

export default DataTable
